<template>
  <div v-if="showGreeting" class="page page-shoplist">
    <div class="page-title">Особенности заказа в iHerb.ru</div>

    <div class="specials">
      <ul>
        <li>
          Не откладывайте заказ.
          <strong>Сроки доставки до 14 дней</strong>
        </li>

        <li>
          Максимальная сумма одного заказа $150.00 (или 5 кг).
          <strong>Можно оформить несколько заказов</strong>
        </li>

        <li>
          Беспошлинный лимит на импорт для частных товаров
          <strong>500 евро в месяц</strong>
        </li>
      </ul>

      <div class="button" @click="skipGreeting">Понятно</div>
    </div>
  </div>

  <div v-else class="page page-shoplist">
    <div class="page-title">Лист покупок</div>

    <div class="shoplist" v-if="tobuy.length > 0">
      <ShopListItem
          v-for="(item, tobuyKey) in tobuy"
          :key="tobuyKey"
          :prescription="item"/>
    </div>

    <div v-else class="shoplist_empty">Список пуст</div>

    <div class="page-title">Куплено</div>

    <div class="shoplist" v-if="bought.length > 0">
      <ShopListItem
          v-for="(item, boughtKey) in bought"
          :key="boughtKey"
          :prescription="item"/>
    </div>

    <div v-else class="shoplist_empty">Список пуст</div>
  </div>
</template>

<script>
  import ShopListItem from './shoplist/Item'

  export default {
    name: 'ShopList',

    components: { ShopListItem },

    data() {
      return {
        itemId: '',
        showGreeting: false, //localStorage.sslg !== 'false'
      };
    },

    computed: {
      tobuy() {
        const items = this.$store.state.prescriptions.filter(
          item => item.bought === false
        );

        items.sort((a, b) => {
          return Date.parse(a.startDate) - Date.parse(b.startDate);
        });

        return items;
      },

      bought() {
        const items = this.$store.state.prescriptions.filter(
          item => item.bought === true
        );

        items.sort((a, b) => {
          return Date.parse(b.startDate) - Date.parse(a.startDate);
        });

        return items;
      },
    },

    methods: {
      skipGreeting() {
        this.showGreeting = false;
        localStorage.sslg = false;
      },
    },
  }
</script>

<style lang="scss">
  @import "../assets/scss/variables.scss";

  .page-shoplist {
    padding-bottom: 10px;

    .shoplist {
      margin: 0 0 10px;
      border-bottom: 1px solid $light-gray;
    }

    .shoplist_empty {
      font-size: 11px;
      font-weight: bold;
      text-align: center;
      color: $primary;
    }

    .specials {
      padding: 0 30px;

      ul {
        margin: 0 0 40px;

        li {
          margin: 0 0 10px;
        }
      }
    }

    .button {
      display: block;
      width: 50%;
      margin: 0 auto;
      padding: 7px 10px 5px;
      background-color: $primary;
      border-radius: 5px;
      text-align: center;
    }
  }
</style>
